import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import cn from 'classnames';
import useMiniCard from 'hooks/useMiniCard';
import { BadgeStyles } from './BadgeStyles';

interface Props {
  className?: string;
  gray?: boolean;
}

const Badge: FC<Props> = observer(({ children, className, gray }) => {
  const {
    display: { isHovered },
  } = useMiniCard();
  const classNames = cn(className, isHovered && 'hover', gray && 'gray');

  return <BadgeStyles className={classNames}>{children}</BadgeStyles>;
});

export default Badge;
